import { useTranslation } from 'react-i18next';
import './style.css';

const MedicalDiagnosis = ({ data }) => {
    const { t } = useTranslation();
    
    return (
        <div className="patient-medical-diagnosis-section">
            <div className="patient-medical-diagnosis-header">
                <div className="patient-medical-diagnosis-icon">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
                        <line x1="12" y1="9" x2="12" y2="13" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        <line x1="12" y1="17" x2="12.01" y2="17" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                </div>
                <h3 className="patient-medical-diagnosis-title">{t('medical-diagnosis-complaint')}</h3>
            </div>
            <div className="patient-medical-diagnosis-content">
                <p className="patient-medical-diagnosis-text">
                    {data?.medicalDiagnosis || 
                    'Patient reports persistent, sharp pain in the right knee localized to the lateral meniscus area, exacerbated during weight-bearing activities and climbing stairs. Initial symptoms began approximately three weeks ago following a brief jog. Patient stated experiencing occasional "locking" sensations. Over-the-counter NSAIDs provide temporary relief, but mechanical instability persists. Seeking a specialist evaluation for potential ligamentous or meniscal pathology and guidance on surgical vs. non-surgical management.'}
                </p>
            </div>
        </div>
    );
};

export default MedicalDiagnosis;

